import { ApiRequestError } from "@nexxt/api-client";
import type { ValidationIssue } from "@nexxt/contracts";
import { errorText } from "../errors";
import { ErrorLine } from "./error-line";
import { IssueBox } from "./issue-box";
import { IssueList } from "./issue-list";

/**
 * Why the domain refused what a dialog or a panel asked for (422), next to the action: `reportError` leaves these to
 * the screen. Nothing for any other error, which is a toast.
 */
export function Refusal({ error, className }: { error: unknown; className?: string }) {
  if (!(error instanceof ApiRequestError) || error.status !== 422) return null;
  return <ErrorLine className={className}>{errorText(error)}</ErrorLine>;
}

interface IssueRefusalProps {
  error: unknown;
  title: string;
  /** An issue in the words of its domain: field, rule and row. */
  text: (issue: ValidationIssue) => string;
}

/**
 * Why the domain refused an action (422), under a title, next to what asked for it: every issue it names, or the
 * refusal in its own words when it names none (a status that no longer takes the action). Nothing for any other error.
 */
export function IssueRefusal({ error, title, text }: IssueRefusalProps) {
  if (!(error instanceof ApiRequestError) || error.status !== 422) return null;
  if (error.issues.length === 0) {
    return (
      <IssueBox title={title}>
        <p>{errorText(error)}</p>
      </IssueBox>
    );
  }
  return <IssueList title={title} issues={error.issues} text={text} />;
}
